import { apiClient } from './client';

export interface Organization {
  id: string;
  name: string;
  role: 'owner' | 'manager' | 'member' | 'viewer' | 'guest';
}

export const organizationsApi = {
  list: async (): Promise<Organization[]> =>
    (await apiClient.get<Organization[]>('/organizations')).data,
};
